import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetGroupServiceConfig = {
  name: "AssetGroup",
  annotations: []
} as ServiceConfig;